import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import no_image from '@doltech/ui/lib/images/No_image_available.png';
import { formatDateString } from '@doltech/utils/lib/date';
import { imgProxyLoader } from '@doltech/utils/lib/image-loader';
import Image from 'next/image';
import * as React from 'react';
import styled from 'styled-components';

import { getParagraphNodeText } from '../../../../ielts-sample/sample.utils';
import { Layout, MainSection, SetupCard } from './SharedSetupCard';

interface VocabSetupCardProps {
  data: any;
}

const StyledMainSection = styled(MainSection)`
  gap: 16px;
  .info-section {
    gap: 8px;
  }
`;

export const VocabSetupCard = (props: VocabSetupCardProps) => {
  const { data } = props;
  const { active, word, partOfSpeech, pronunciation, definition, lastModifiedAt, image, example } =
    data;

  const exampleText = React.useMemo(() => {
    return getParagraphNodeText(
      example?.content === 'string' ? JSON.parse(example.content) : example?.content
    );
  }, [example]);
  return (
    <SetupCard bordered>
      <Layout>
        <StyledMainSection>
          <div className="header-section">
            <div className="image-section">
              <Image
                width="100%"
                height="100%"
                alt={image?.alt || ''}
                src={image?.url || no_image}
                objectFit="cover"
                loader={imgProxyLoader}
              />
            </div>
            {active && (
              <Typography.Paragraph
                className="active-label"
                variant="semi-bold/12"
                color="green100"
                ellipsis={{ rows: 1 }}
              >
                Currently active
              </Typography.Paragraph>
            )}
          </div>
          <div className="info-section">
            <div>
              <Typography.Text variant="semi-bold/16">{word} </Typography.Text>
              <Typography.Text variant="regular/16">{partOfSpeech} </Typography.Text>
              <Typography.Text variant="regular/16">{pronunciation}</Typography.Text>
            </div>
            <div>
              <Typography.Text variant="semi-bold/16">Definition: </Typography.Text>
              <Typography.Text variant="regular/16">{definition}</Typography.Text>
            </div>
            <div>
              <Typography.Text variant="semi-bold/16">Example: </Typography.Text>
              <Typography.Text variant="regular/16">{exampleText}</Typography.Text>
            </div>

            <Typography.Paragraph variant="regular/14" color="gray100">
              Last modified: {formatDateString(lastModifiedAt)}
            </Typography.Paragraph>
          </div>
        </StyledMainSection>
      </Layout>
    </SetupCard>
  );
};
